import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Users, Maximize, Bed } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

export const RoomCard = ({ room, index }) => {
  const { t, language } = useLanguage();

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: index * 0.1 }}
      viewport={{ once: true }}
      className="group"
      data-testid={`room-card-${room.id}`}
    >
      <Link to={`/rooms/${room.id}`}>
        <div className="relative overflow-hidden mb-6">
          <img
            src={room.images[0]}
            alt={room.name[language] || room.name.en}
            className="w-full h-[400px] object-cover transition-transform duration-700 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0F1F3C]/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
          <div className="absolute bottom-0 left-0 right-0 p-6 translate-y-full group-hover:translate-y-0 transition-transform duration-500">
            <span className="bg-[#D4AF37] text-white px-4 py-2 text-xs uppercase tracking-widest font-sans">
              {t('rooms.viewDetails')}
            </span>
          </div>
        </div>
        <div className="space-y-3">
          <h3 className="font-serif text-2xl text-[#0F1F3C] group-hover:text-[#D4AF37] transition-colors">
            {room.name[language] || room.name.en}
          </h3>
          <p className="text-[#64748B] font-sans text-sm line-clamp-2">
            {room.description[language] || room.description.en}
          </p>
          <div className="flex items-center space-x-6 pt-2">
            <div className="flex items-center space-x-2 text-[#0F1F3C]/60">
              <Maximize className="w-4 h-4" />
              <span className="text-xs font-sans">{room.size_sqm} {t('rooms.sqm')}</span>
            </div>
            <div className="flex items-center space-x-2 text-[#0F1F3C]/60">
              <Users className="w-4 h-4" />
              <span className="text-xs font-sans">{room.max_guests}</span>
            </div>
            <div className="flex items-center space-x-2 text-[#0F1F3C]/60">
              <Bed className="w-4 h-4" />
              <span className="text-xs font-sans">{room.bed_type}</span>
            </div>
          </div>
          <div className="pt-4 border-t border-gray-100">
            <p className="text-[#0F1F3C]">
              <span className="text-xs uppercase tracking-wider text-[#64748B] font-sans">{t('rooms.from')}</span>
              <span className="font-serif text-2xl ml-2">€{room.price_per_night}</span>
              <span className="text-sm text-[#64748B] font-sans">/{t('booking.night')}</span>
            </p>
          </div>
        </div>
      </Link>
    </motion.div>
  );
};
